<template>
  <form @submit.prevent>
     <CModal
        :title.sync="title"
        color="info"
        size="lg"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
             <label > Group Name Youth</label>
             <CRow >
              <CCol >
              <b-input v-model="form.name" placeholder='Group Name' :class="errors.name ? 'is-invalid' : ''" class="mb-1"> </b-input>
              <b-form-invalid-feedback >
              Your group name must be filled
              </b-form-invalid-feedback>
              </CCol>
            </CRow>
            <label class="mt-2"> Description </label>
             <CRow >
              <CCol >
                <c-textarea v-model="form.description" placeholder='Description' rows="5" class="mb-3" />
              </CCol>
            </CRow>
            <!-- <CRow class="mt-0"    >
              <CCol >
                <label> Coach </label>
               <multiselect v-model="form.coach_id" placeholder="Manage Coach" :custom-label="coachName" :options="options" label="text" track-by="value"></multiselect>
            
              </CCol>
            </CRow> -->
          </CCol> 
          </CRow>
     
        
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id,form.coach_id)"  variant="outline" color="info">Edit</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import group from '@/services/coachgroupyouth';
import member from '@/services/member'

import Multiselect from 'vue-multiselect'

export default {
name: 'coachgroupmodal',
components: {Multiselect },
  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      errors: {},
      errors_from_backend: [],
      form:{
        id:'',
        name:'',
        description:'',
        coach_id:[],
      },
      
      options:[],
      largeModal:false,
      largeModal1:false,
      loading: false,
    }
  },
   computed: {

   },
  mounted(){
    this.load()
  },
  created () {
    var self = this;
      EventBus.$on('OPEN_MODAL_GROUP', (params) => {
      if(params.data){
      group.getGroupbyID(params.data)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.id = res.data.id;
      self.form.name = res.data.name;
      self.form.description = res.data.description;
      self.form.coach_id = res.data.coach_id;
      

       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
         }else{
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.id = "";
      self.form.name = "";
      self.form.description = "";
      self.form.coach_id = "";
      }
    });
    this.form.uuid = this.$route.query.Pud
   this.options = []
    // member.getMember()
    // .then(res => {
    //   console.log(res.data.member)
    //   for (let i=0; i <= res.data.member.length-1; i++){
    //     //alert
    //     this.options.push({text: res.data.member[i].name, value:res.data.member[i].uuid})
    //     console.log('test');
    //   }
    // }).catch((er) =>{
    //   var params = {title: 'Error', mode:'danger', data:err.response.data.message}
    //     EventBus.$emit('OPEN_MODAL_ALERT', params)
    //      console.log(this.options)
    // })   
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(coach_id){
      this.loading = true;
       var param = {
            coach_id: this.form.coach_id['value'],
          }
      if (this.check_form()) {
      group.createGroup(this.form,param)
      .then(res => {
        // group.updateCoach(this.$route.query.Pud, param)
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        this.show = false;
      }).catch((err) => {
      this.loading = false;
      alert(err.response.data.message);
      //alert(JSON.stringify(err.response.data.errors));
      if (err.response.data.errors != null) {
          this.errors_from_backend = err.response.data.errors;
          console.log(JSON.stringify(err.response.data.errors));
      }
    });
    } else {
      this.loading = false;
    }
  },

    update(id){
      this.show = false;
      group.updateGroup(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        this.show = false;  
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    check_form: function(e) {
         this.errors = {};
         if (!this.form.name) {
            this.errors["name"] = "1";
         }
         if (
            this.form.name 
         ) {
            return true;
         } else {
            return false;
         }
      }, 
   
  }
}
</script>



<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>